export enum UpdateClientFactorState {
    /// <summary>
        /// دریافت شده توسط رستوران
        /// </summary>
        GetByRest = 1,
        /// <summary>
        /// شناسایی شده 
        /// </summary>
        Detected = 2,
        /// <summary>
        /// ثبت در لیست فاکتورها
        /// </summary>
        InsertInFactorList = 3,
        /// <summary>
        /// پرینت به آشپزخانه
        /// </summary>
        PrintToKitchen = 4,
        /// <summary>
        /// ارسال به مشتری 
        /// </summary>
        SentToCustomer = 5,
        /// <summary>
        /// کنسل شده - عدم تایید آدرس
        /// </summary>
        CanceledForAddress = 6,
        /// <summary>
        /// کنسل شده - عدم موجودی غذا 
        /// </summary>
        CancelForNoFoodRemain = 7,
        /// <summary>
        /// کنسل شده - توسط مشتری 
        /// </summary>
        CancelByCustomer = 8,
        /// <summary>
        /// نیاز به تماس - اختالف قیمت با منو 
        /// </summary>
        Price_NeedToCall = 9,
        /// <summary>
        /// نیاز به تماس - مشکل آدرس 
        /// </summary>
        Adress_NeedToCall = 10,
        /// <summary>
        /// نیاز به تماس - هزینه پیک 
        /// </summary>
        DeliveryPrice_NeedToCall = 11,
        /// <summary>
        /// نیاز به تماس - غذا تمام شده 
        /// </summary>
        NotStock_NeedToCall = 12,
        /// <summary>
        /// نیاز به تماس - اطالعات مشتری 
        /// </summary>
        CustomerData_NeedToCall = 13,
        /// <summary>
        /// نیاز به تماس 
        /// </summary>
        Other_NeedToCall = 14
  }
